import { render, staticRenderFns } from "./check.vue?vue&type=template&id=a747b712"
import script from "./check.vue?vue&type=script&lang=ts"
export * from "./check.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports